
import { ReducerRegistry } from '../redux';

import { SET_AUDIO_ONLY, SET_CARMODE_AUDIO_ONLY } from './actionTypes';


const DEFAULT_STATE = {
    enabled: false,
    inCarModeEnabled: false
};


ReducerRegistry.register('features/base/audio-only', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
    case SET_AUDIO_ONLY:
        return {
            ...state,
            enabled: action.audioOnly
        };
    case SET_CARMODE_AUDIO_ONLY:
        return {
            ...state,
            inCarModeEnabled: action.audioOnlyCarMode
        };
    default:
        return state;
    }
});
